import React, { useEffect, useState } from 'react';
import { Collapse, Alert, IconButton } from '@mui/material/';
import { Close } from '@mui/icons-material';

function TopAlert({ alert }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (alert) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [alert])

  const handleCloseAlert = () => {
    setOpen(false);
  }

  if (alert) {
    return (
      <Collapse in={open}>
        <Alert
          className='top-alert-container'
          icon={false}
          action={
            alert.canClose ? (
              <IconButton onClick={handleCloseAlert}><Close /></IconButton>
            ) : null
          }
        >
          <span dangerouslySetInnerHTML={{ __html: alert.message }} />
        </Alert>
      </Collapse>
    );
  }
}

export default TopAlert;
